<template>
  <div>
    <v-tooltip bottom open-delay="300">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="dialog = true"
          v-bind="attrs"
          v-on="on"
          outlined
          height="40px"
          class="ml-4"
          color="rgb(158 158 158)"
        >
          <v-icon color="#6f6c6c">mdi-settings</v-icon>
        </v-btn>
      </template>
      <span>Ajustar os parâmetros</span>
    </v-tooltip>

    <v-dialog persistent v-model="dialog" max-width="750px" content-class="bra-20">
      <v-card>
        <v-card-title>
          <v-toolbar-title>Parâmetros de DRP {{ drpReversoSelecionado ? 'Reverso' : ' de Distribuição'}}</v-toolbar-title>

          <v-spacer />

          <v-btn icon @click="fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-5">
          <v-select
            v-model="itemEditado.filiais"
            :items="items"
            label="Filiais onde os valores serão aplicados"
            item-text="descricao"
            item-value="filial"
            outlined
            multiple
            clearable
            :error-messages="filiaisErrors"
            @input="$v.itemEditado.filiais.$touch()"
            @blur="$v.itemEditado.filiais.$touch()"
          >
            <template v-slot:selection="{ item }">
              <v-chip small>
                <span>{{ item.filial }}</span>
              </v-chip>
            </template>

            <template v-slot:prepend-item>
              <v-list-item class="sys-item-prepended-list px-4 py-2" @click="selecionarTodasFiliais()">
                <template v-if="itemEditado.filiais.length === items.length">
                  <v-icon color="primary">mdi-checkbox-marked</v-icon>
                  <span class="subtitle-1 ml-3">Desmarcar todas as Filiais</span>
                </template>

                <template v-else>
                  <v-icon v-if="!itemEditado.filiais.length">mdi-checkbox-blank-outline</v-icon>
                  <v-icon v-else color="primary">mdi-minus-box</v-icon>
                  <span class="subtitle-1 ml-3">Selecionar todas as Filiais</span>
                </template>
              </v-list-item>

              <v-divider />
            </template>
          </v-select>

          <v-row class="pa-0 ma-0">
            <v-col cols="6" class="pa-0 pr-2">
              <v-text-field
                label="Cobertura de Estoque Desejada"
                placeholder="Quantidade de dias"
                outlined
                autofocus
                clearable
                suffix="dias"
                v-model="itemEditado.cobertura_estoque"
                :error-messages="coberturaEstoqueErrors"
                @input="$v.itemEditado.cobertura_estoque.$touch()"
                @blur="$v.itemEditado.cobertura_estoque.$touch()"
                @keyup="itemEditado.cobertura_estoque = apenasNumeros(itemEditado.cobertura_estoque)"
                @focus="$event.target.select()"
              ></v-text-field>
            </v-col>

            <v-col cols="6" class="pa-0 pl-2">
              <v-text-field
                :label="drpReversoSelecionado ? 'Tempo Médio de Distribuição' : 'Tempo Médio de Reabastecimento CD'"
                placeholder="Quantidade de dias"
                outlined
                clearable
                suffix="dias"
                v-model="itemEditado.tempo"
                :error-messages="tempoErrors"
                @input="$v.itemEditado.tempo.$touch()"
                @blur="$v.itemEditado.tempo.$touch()"
                @keyup="itemEditado.tempo = apenasNumeros(itemEditado.tempo)"
                @focus="$event.target.select()"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-simple-table class="titulo-tabela-top table-full-screen" dense fixed-header height="38vh">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Filial</th>
                  <th>Cobertura de Estoque</th>
                  <th>Tempo Ressuprimento</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.filial">
                  <td>{{ item.filial }}</td>
                  <template v-if="drpReversoSelecionado">
                    <td>{{ item.cobertura_drp_reverso }}</td>
                    <td>{{ item.tempo_ressuprimento_drp_reverso }}</td>
                  </template>
                  <template v-else>
                    <td>{{ item.cobertura_drp }}</td>
                    <td>{{ item.tempo_ressuprimento_drp }}</td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn text color="primary" @click="ajustarParamentros">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DrpAPI from "../../../api/drp";
import { required } from "vuelidate/lib/validators";

export default {
  props: ["grupoDrp", "items", "filialSelecionada", "drpReversoSelecionado"],
  data: () => ({
    dialog: false,
    itemEditado: {
      cobertura_estoque: 0,
      tempo: 0,
      filiais: []
    },
  }),
  validations: {
    itemEditado: {
      cobertura_estoque: {
        required,
        min() {
          return this.itemEditado.cobertura_estoque >= 1;
        },
        limiteMaximo () {
          if (this.itemEditado.filiais.length > 1 || this.limitesFilialSelecionada.limite_cobertura == 0) {
            return true
          }

          return this.itemEditado.cobertura_estoque <= this.limitesFilialSelecionada.limite_cobertura
        }
      },
      tempo: {
        required,
        min() {
          return this.itemEditado.tempo >= 1;
        },
        limiteMaximo () {
          if (this.itemEditado.filiais.length > 1 || this.limitesFilialSelecionada.limite_distribuicao == 0) {
            return true
          }

          return this.itemEditado.tempo <= this.limitesFilialSelecionada.limite_distribuicao
        }
      },
      filiais: {
        required() {
          return this.itemEditado.filiais.length > 0
        }
      }
    }
  },
  watch: {
    dialog() {
      if (this.dialog) {
        if (this.filialSelecionada.length === 0) {
          this.selecionarTodasFiliais(true)
        } else {
          this.itemEditado.filiais = this.filialSelecionada
        }

        this.itemEditado.cobertura_estoque = ''
        this.itemEditado.tempo = ''
        this.$v.$reset()
      }
    }
  },
  computed: {
    coberturaEstoqueErrors() {
      const errors = [];
      if (!this.$v.itemEditado.cobertura_estoque.$dirty) return errors;
      !this.$v.itemEditado.cobertura_estoque.required && errors.push("Campo Obrigatório.");
      !this.$v.itemEditado.cobertura_estoque.min && errors.push("Valor mínimo é 1.");
      !this.$v.itemEditado.cobertura_estoque.limiteMaximo && errors.push(`Limite máximo é ${this.limitesFilialSelecionada.limite_cobertura}.`);
      return errors;
    },
    tempoErrors() {
      const errors = [];
      if (!this.$v.itemEditado.tempo.$dirty) return errors;
      !this.$v.itemEditado.tempo.required && errors.push("Campo Obrigatório.");
      !this.$v.itemEditado.tempo.min && errors.push("Valor mínimo é 1.");
      !this.$v.itemEditado.tempo.limiteMaximo && errors.push(`Limite máximo é ${this.limitesFilialSelecionada.limite_distribuicao}.`);
      return errors;
    },
    filiaisErrors() {
      const errors = [];
      if (!this.$v.itemEditado.filiais.$dirty) return errors;
      !this.$v.itemEditado.filiais.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    limitesFilialSelecionada () {
      const semLimites = {limite_cobertura: 0, limite_distribuicao: 0}

      if (this.itemEditado.filiais.length > 1) {
        return semLimites
      }

      const itemFilial = this.items.filter(item => this.itemEditado.filiais.includes(item.filial))

      if (!itemFilial[0]) {
        return semLimites
      }

      const {
        limite_cobertura,
        limite_distribuicao,
        limite_cobertura_reverso,
        limite_distribuicao_reverso
      } = itemFilial[0]

      if (this.drpReversoSelecionado) {
        return {limite_cobertura: limite_cobertura_reverso, limite_distribuicao: limite_distribuicao_reverso}
      }

      return {limite_cobertura, limite_distribuicao}
    }
  },
  methods: {
    apenasNumeros (str) {
      return `${str}`.replace(/([^\d])+/gim, '')
    },
    fechar() {
      this.dialog = false
    },
    selecionarTodasFiliais(force = false) {
      if (this.itemEditado.filiais.length === this.items.length && !force) {
        this.itemEditado.filiais = [];
      } else {
        this.itemEditado.filiais = this.Helpers.arrayColumn(this.items, 'filial')
      }
    },
    ajustarParamentros() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          grupo: parseInt(this.grupoDrp),
          filiais: this.itemEditado.filiais,
          cobertura_estoque: parseInt(this.itemEditado.cobertura_estoque),
          tempo: parseInt(this.itemEditado.tempo),
          drpReversoSelecionado: this.drpReversoSelecionado
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.ajustarParametros(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.$emit("atualizar-parametros");
              this.fechar();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    }
  }
}
</script>
